import { createContext } from "react";

import { Granularity } from "server/dwhApi/common.js";

import { REPORTING_TABLE_UNIT } from "../../types";

export type IReportingTableContext = {
  granularity: Granularity;
  setGranularity: (value: Granularity) => void;
  unit: REPORTING_TABLE_UNIT;
  setUnit: (value: REPORTING_TABLE_UNIT) => void;
  showZones: boolean;
  setShowZones: (value: boolean) => void;
  nrSelected: number;
  nrTotal: number;
  isLoading: boolean;
};

export const ReportingTableContext = createContext({
  granularity: Granularity.WEEK,
  setGranularity: () => {},
  unit: REPORTING_TABLE_UNIT.WEIGHT,
  setUnit: () => {},
  showZones: false,
  setShowZones: () => {},
  nrSelected: 0,
  nrTotal: 0,
  isLoading: false,
} as IReportingTableContext);
